module.exports = __webpack_public_path__ + "static/media/enagic-card.1481dcef.jfif";